import styled from 'styled-components';
import { RowLine, LabelRow, SpanBlock } from '../CardMobile/style';

export const Container = styled.div`
  width: 100%;

  .buttonModalConversacao {
    font-size: 12px;
    width: 100%;
  }
`;

export const Titulo = styled.span`
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
`;

export const ContainerPanel = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;

export const SecRowLine = styled(RowLine)``;
export const SecLabelRow = styled(LabelRow)``;
export const SecSpanBlock = styled(SpanBlock)``;

export const Solicitacao = styled.span`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 130%;
  color: rgba(0, 0, 0, 0.8);
`;

export const Anexos = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: relative;

  span {
    width: 100%;
    text-align: right;
  }
`;

export const StyledContainerButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: baseline;

  .anexoButton {
    background: none;
    border: none;
  }

  .sendButton {
    width: 50px;
    height: 50px;
    background: #1890ff;
    box-shadow: 0px 2px 0px rgba(0, 0, 0, 0.016);
    border-radius: 2px;
    color: #fff;
    font-size: 20px;
  }

  .ant-upload-list-picture-container {
    max-width: 150px;
  }
  .ant-upload.ant-upload-select-picture-card {
    background-color: transparent;
    border: none;
    align-self: center;
    text-align: center;
    margin: 0 auto;
  }
`;

export const ButtonUpload = styled.button``;
